import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Form, Radio, Menu } from 'semantic-ui-react';
import { PiboMenu, PiboMenuItem } from '../PiboComponents';

const PiboReaction = props => {
  const { t } = useTranslation();
  const { value: propLevel, list, handleChange } = props;
  const [level, setLevel] = useState(propLevel || 0);

  useEffect(() => {
    setLevel(propLevel || 0);
  }, [propLevel]);

  const handleLevelChange = (e, { value: v }) => {
    handleChange(v);
    setLevel(v);
  };

  return (
    <Grid centered padded>
      <Grid.Row>
        <Grid.Column>
          <PiboMenu vertical fluid>
            <Form>
              {list &&
                list.length > 0 &&
                list.map(item => (
                  // eslint-disable-next-line react/no-array-index-key
                  <PiboMenuItem
                    key={item.id}
                    value={item.value}
                    onClick={handleLevelChange}
                  >
                    <Form.Field style={{ margin: 0 }}>
                      <Radio
                        label={t(item.label)}
                        name="radioGroup"
                        value={item.value}
                        checked={level.toString() === item.value}
                        onChange={handleLevelChange}
                      />
                    </Form.Field>
                    <Menu.Menu style={{ margin: 0 }}>
                      <Menu.Item
                        name={
                          Number(item.value) > 0
                            ? '파이보가 사람에 맞춰 방향을 바꾸고, 상황에 따라 먼저 대화를 건네거나 봇을 스스로 수행합니다. '
                            : '파이보가 음성 및 기타 명령을 통해서만 봇, 대화 등의 기능을 수행합니다.'
                        }
                        style={{ paddingLeft: '2.2em', lineHeight: '1.25' }}
                      />
                    </Menu.Menu>
                  </PiboMenuItem>
                ))}
            </Form>
          </PiboMenu>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default PiboReaction;
